/* UserType */
export interface UserType {
    id: number;
    type_name: string;
    key_name: string;
    logo: string | null;
    status: 1 | 0;
}

export const mapUserType = (data: any): UserType => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: UserType = {
        id: data.id,
        type_name: data.type_name,
        key_name: data.key_name,
        logo: data.logo ?? null,
        status: data.status,
    };

    return res;
};

export const mapUserTypes = (data: any[]): UserType[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapUserType);
};
/*  */

/* Module */
export interface Module {
    id: number;
    order_no: number;
    module: string;
    long_description: string;
    status: 1 | 0;
    module_feature: Features[];
}

export const mapModule = (data: any): Module => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: Module = {
        id: data.id,
        order_no: data.order_no,
        module: data.module,
        long_description: data.long_description,
        status: data.status,
        module_feature: (data.module_feature && Array.isArray(data.module_feature)) ? mapFeatures(data.module_feature) : [],
    };

    return res;
};

export const mapModules = (data: any[]): Module[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapModule);
};

/* Features */
export interface Features {
    id: number;
    module_id: number;
    order_no: number;
    feature: string;
    long_description: string;
    available_for: number[];
    status: 1 | 0;
}

export const mapFeature = (data: any): Features => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: Features = {
        id: data.id,
        module_id: data.module_id,
        order_no: data.order_no,
        feature: data.feature,
        long_description: data.long_description,
        available_for: data.available_for,
        status: data.status,
    };

    return res;
};

export const mapFeatures = (data: any[]): Features[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFeature);
};
/*  */